module.exports = __webpack_public_path__ + "static/media/bunksq.196f21b6.png";